const processSteps = [
  {
    step: 1,
    title: 'Discover',
    description: 'We dive deep into your business objectives, challenges, and target audience. This discovery phase ensures we fully understand your vision and align our strategy accordingly.',
    subtext: 'Step 1/5',
    color: '#1d4e89'
  },
  {
    step: 2,
    title: 'Strategize',
    description: 'Based on insights gathered, we develop a clear, actionable roadmap—defining the architecture, timelines, and technologies needed to bring your product to life.',
    subtext: 'Step 2/5',
    color: '#1a5b92'
  },
  {
    step: 3,
    title: 'Design',
    description: 'Our design team crafts clean, intuitive, and user-focused interfaces that blend form and function—ensuring an exceptional user experience from the start.',
    subtext: 'Step 3/5',
    color: '#0f80aa'
  },
  {
    step: 4,
    title: 'Develop',
    description: 'Using agile methodologies, we build your solution with precision. Iterative releases, constant feedback, and code transparency keep you involved and in control.',
    subtext: 'Step 4/5',
    color: '#04a6c2'
  },
  {
    step: 5,
    title: 'Deliver & Evolve',
    description: 'After thorough testing and validation, we deploy your product with confidence. Post-launch, we stay with you—offering continuous support, updates, and enhancements as your needs grow.',
    subtext: 'Step 5/5',
    color: '#20bac5'
  }
];

module.exports = {processSteps};